import React, { useCallback, useEffect, useMemo, useState } from "react"
import { Checkbox } from "@yuanfudao/metis-web-component"
import { useLocation } from 'react-router-dom'
import { octopus } from '@/octopus'
import { checkoutLogin, cleanLoginStorage, getTokenTenantId, isInStudent, redirectByUrl, runAtNextFrame, saveTokenToStorage, storageTidKey } from '@yuanfudao/metis-unified-login'
import { isElectron } from '@/utils/os'
import { BridgeAppReady, bridgeData } from '@/electron'
import { getUserTenantsIns, wxOauthLogin } from '@yuanfudao/metis-unified-login/es/service/login'
import { useGlobalState } from '@/store'
import CustomTab2 from "@/components/custom-tab2"
import { ProjectConfig } from '@/project-config/index'
import iconInfo from '@/assets/login2/icon-info.png'
import iconArrowRight from '@/assets/login2/arrow-right.png'

import WxScanBind from "../wx-scan-bind"
import { QrCodeContent } from "../qr-code-content"
import { CodeContent } from "../code-content"
import { loginTypeStorageKey } from '../../index'
import lessModule from "./index.module.less"
import pageConfig from '@/config'
import qs from "qs"
import { useHandleQuery } from "@/hooks/common"
import config from "@yuanfudao/metis-unified-login/es/config"
import { useMsgFail } from "@yuanfudao/metis-unified-login/es/utils/antd-message"

export enum LOGIN_TYPE {
  QRCODE = 'qrCode',
  CODE = 'code',
  PASSWORD = 'password',
}
// 用户协议
let link1 = 'https://ke.feixiangxingqiu.com/policy/agreement-teacher.html'
// 隐私政策
let link2 = 'https://ke.feixiangxingqiu.com/policy/privacy-teacher.html'
// 儿童隐私保护政策
let link3 = 'https://ke.feixiangxingqiu.com/policy/child-privacy-teacher.html'
if (isInStudent()) {
  link1 = 'https://ke.feixiangxingqiu.com/policy/agreement-student.html'
  link2 = 'https://ke.feixiangxingqiu.com/policy/privacy-student.html'
  link3 = 'https://ke.feixiangxingqiu.com/policy/child-privacy-student.html'
}

export default function LoginLeftContainer() {
  const loginConf = ProjectConfig.loginLeft.LoginTypesList
  const location = useLocation()
  // const history = useHistory()
  const { setIsLogin } = useGlobalState()
  const [showBindPhone, setShowBindPhone] = useState(false)
  const [loginType, setLoginType] = useState(ProjectConfig.loginLeft.defaultLoginType)
  const [isCheckAgreement, setIsCheckAgreement] = useState<boolean>(false)

  const [checkboxWrapClass, setCheckboxWrapClass] = useState('')
  const [wxTokenState, setWxTokenState] = useState('')
  const [wxCsrfToken, setWxCsrfToken] = useState('')
  const { getQuery, modQuery } = useHandleQuery()

  const MsgFail = useMsgFail()
  const lectioOrZhixue: {version: 'zhixue' | 'lectio'} | null = useMemo(() => {
    const redirect = getQuery().redirectUrl as string
    if (!redirect) {
      return {
        version: 'zhixue',
      }
    }
    try {
      const decoded = decodeURIComponent(redirect)
      const link = document.createElement('a')
      link.href = decoded
      return {
        version: link.hostname.includes('ke.feixiangxingqiu') ? 'lectio' : 'zhixue',
      }
    } catch (e) {
      console.warn(e)
      return null
    }
  }, [getQuery])

  const Agreement = (
    <div className={`${lessModule.agreement} ${checkboxWrapClass}`}>
      <Checkbox
        checked={isCheckAgreement}
        onChange={(e) => {
          setIsCheckAgreement(e.target.checked)
        }}
      />
      <div className={lessModule.textWrap} onClick={(e) => e.stopPropagation()}>
        我已阅读并同意
        <span
          className={lessModule.link}
          onClick={() => {
            if (isElectron) {
              window.require("electron").shell.openExternal(link1)
              return
            }
            window.open(link1, "_blank")
          }}
        >
          《用户协议》
        </span>
        <span
          className={lessModule.link}
          onClick={() => {
            const realLink = lectioOrZhixue?.version === 'lectio' ? pageConfig.lectioPrivacy : link2
            if (isElectron) {
              window.require("electron").shell.openExternal(realLink)
              return
            }
            window.open(realLink, "_blank")
          }}
        >
          《隐私政策》
        </span>
        <span
          className={lessModule.link}
          onClick={() => {
            const realLink = lectioOrZhixue?.version === 'lectio' ? pageConfig.lectioChildPrivacy : link3
            if (isElectron) {
              window.require("electron").shell.openExternal(realLink)
              return
            }
            window.open(realLink, "_blank")
          }}
        >
          《儿童隐私保护政策》
        </span>
      </div>
    </div>
  )

  const switchInfo = useMemo(() => {
    // 仅 web 端展示
    if (isElectron) {
      return null
    }
    if (!ProjectConfig.loginLeft.showSwitchInfo) {
      return null
    }
    const redirect = getQuery().redirectUrl as string
    if (!redirect) {
      return {
        version: 'teacher',
      }
    }
    try {
      const decoded = decodeURIComponent(redirect)
      const link = document.createElement('a')
      link.href = decoded
      if (
        link.hostname.includes('zhixue.feixiangxingqiu') ||
        link.hostname.includes('teacher.feixiangxingqiu') ||
        link.hostname.includes('laoshi.feixiangxingqiu') ||
        link.hostname.includes('xuesheng.feixiangxingqiu'
      )) {
        return {
          version: link.hostname.includes('xuesheng.feixiangxingqiu') ? 'student' : 'teacher',
        }
      }
      return null
    } catch (e) {
      console.warn(e)
      return null
    }
  }, [getQuery])

  const onSwitchVersion = useCallback(() => {
    const redirect = getQuery().redirectUrl as string
    console.log('redirect', redirect)
    // 没有 redirectUrl，默认为老师版，需要切换到学生版
    if (!redirect) {
      modQuery({
        redirectUrl: config.defaultRedirectStudent
      })
      return
    }
    try {
      const decoded = decodeURIComponent(redirect)
      console.log('decoded', decoded)
      const link = document.createElement('a')
      link.href = decoded
      if (link.host.includes('xuesheng.feixiangxingqiu')) {
        link.host = link.host.replace('xuesheng', 'laoshi')
      } else {
        const host = link.hostname.split('.')[0]
        console.log('host', host)
        link.host = link.host.replace(host, 'xuesheng')
      }
      console.log('link.href', link.href)
      modQuery({
        redirectUrl: `${link.origin}${link.pathname}${link.search}`
      })
    } catch (e) {
      console.warn(e)
    }
  }, [getQuery, modQuery])

  // 登录成功后
  const afterLoginSuccess = useCallback(async () => {
    try {
      const curTid = getTokenTenantId()
      localStorage.setItem(storageTidKey, curTid ? String(curTid) : '')
      if (isInStudent()) {
        redirectByUrl()
      } else {
        const fn = ProjectConfig.loginLeft.LoginTenantIdFn || getUserTenantsIns
        const { data: { code, result: r, message } } = await fn()
        if (code === '0') {
          const result = (r as any[]).filter((i: any) => i[ProjectConfig.loginLeft.LoginTenantIdFnFilterKey || 'inInstitution'])
          if (result.length > 0) {
            redirectByUrl()
          } else {
            cleanLoginStorage()
            MsgFail(ProjectConfig.loginLeft.LoginTenantIdFnErrorText || '当前账号不在学校内，暂无法使用')
            if (ProjectConfig.loginLeft.goToQrCodeWhenTenantsEmpty) {
              if (showBindPhone) {
                setShowBindPhone(false)
                setLoginType(LOGIN_TYPE.QRCODE)
                setIsCheckAgreement(true)
              }
            }
          }
        } else {
          MsgFail(message || '登录错误，请稍候再试')
          cleanLoginStorage()
        }
      }
    } catch (e) {
      console.warn(e)
      cleanLoginStorage()
      MsgFail('网络错误，请稍候再试')
    }
    // if (isElectron) {
    //   const redirect = getUrlQuery().redirectUrl as string
    //   BridgeRouteRedirect({ arguments: { url: redirect || encodeURIComponent(config.MAIN_APP_URL) } })
    // } else {
    //   redirectByUrl()
    // }
  }, [MsgFail, showBindPhone])

  const afterQrCodeLogin = useCallback(async () => {
    try {
      const search = window.location.search.slice(1)
      const query = qs.parse(search)
      // console.log('query', query)
      setWxCsrfToken(query.csrfToken as string)
      window.history.replaceState({}, '', `${window.location.origin}${window.location.pathname}${window.location.hash}`)
      window.history.replaceState('', '', window.location.href.replace('/bind', ''))// 绑定账号页面刷新后回到登录页面重新扫码
      const { data: { code, result, message } } = await wxOauthLogin({
        userAgent: 'web',
        csrfToken: query.csrfToken as string,
        oauthRequest: {
          appId: query.appId as string,
          code: query.code as string,
        }
      })
      if (code === '0') {
        if (result) {
          const { boundMetis, wxToken, token } = result
          if (boundMetis) {
            const at = token.accessToken
            const rt = token.refreshToken
            saveTokenToStorage(at, rt)
            setIsLogin(true)
            afterLoginSuccess()
          } else {
            setWxTokenState(wxToken)
            setShowBindPhone(true)
          }
        }
      } else {
        MsgFail(message || '登录失败，请稍后重试')
      }
    } catch (e) {
      console.warn(e)
      octopus.rum.addError(e, { process: 'throwable' })
    }
  }, [MsgFail, afterLoginSuccess, setIsLogin])

  useEffect(() => {
    runAtNextFrame(() => {
      runAtNextFrame(() => {
        if (isElectron && !bridgeData.bridgeAppReady) {
          BridgeAppReady()
        }
      })
    })
    const init = async () => {
      const login = await checkoutLogin()
      if (login) {
        // 新版登录，选学校属于业务范畴，登录不需要判断了
        // const notChoose = await userLoginButNotChooseRole()
        // if (notChoose) {
        //   goToChooseSchool()
        //   return
        // }
        redirectByUrl()
        return
      }
      const type = localStorage.getItem(loginTypeStorageKey)
      if (type && loginConf.find((i) => i.value === type)) {
        setLoginType(type as LOGIN_TYPE)
      }
    }
    // 扫码登录后由服务端重定向到/login/bind
    if (location.pathname.includes('/login/bind')) {
      afterQrCodeLogin()
    } else {
      init()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const changeLoginType = (type: LOGIN_TYPE) => {
    setLoginType(type)
    localStorage.setItem(loginTypeStorageKey, type)
  }

  const onNotAgree = () => {
    setCheckboxWrapClass(lessModule.checkboxHover)
    setTimeout(() => {
      setCheckboxWrapClass('')
    }, 1000)
  }

  if (showBindPhone) {
    return (
      <WxScanBind
        onBack={() => setShowBindPhone(false)}
        afterBindSuccess={afterLoginSuccess}
        wxToken={wxTokenState}
        csrfToken={wxCsrfToken}
      />
    )
  }

  return (
    <div
      className={`${lessModule.leftInner} ${switchInfo ? lessModule.showSwitch : ''}`}
    >
      {
        switchInfo && (
          <div className={lessModule.switch}>
            <div className={lessModule.left}>
              <img
                src={iconInfo}
                className={lessModule.iconInfo}
                alt=""
              />
              您正在登录飞象星球
              <span className={lessModule.version}>“{switchInfo.version === 'teacher' ? '老师版' : '学生版'}”</span>
            </div>
            <div className={lessModule.right} onClick={onSwitchVersion}>
              切换为{switchInfo.version === 'student' ? '老师版' : '学生版'}
              <img
                src={iconArrowRight}
                className={lessModule.iconArrow}
                alt=""
              />
            </div>
          </div>
        )
      }
      <div className={`${lessModule.loginWrap} blur-bg`} id="loginWrap">
        <div className={lessModule.tabWrap}>
          <CustomTab2
            dataSource={loginConf}
            tabProps={{
              activeKey: loginType,
              onChange: (data) => changeLoginType(data as LOGIN_TYPE),
            }}
          />
        </div>
        <div className={lessModule.loginContent}>
          <div
            className={
              loginType !== LOGIN_TYPE.QRCODE ? lessModule.hideContent : ""
            }
          >
            <QrCodeContent
              isCheckAgreement={isCheckAgreement}
              afterLoginSuccess={afterLoginSuccess}
            />
          </div>
          <div
            className={
              loginType === LOGIN_TYPE.QRCODE ? lessModule.hideContent : ""
            }
          >
            <CodeContent
              loginType={loginType}
              isCheckAgreement={isCheckAgreement}
              handleChangeLoginType={(type: LOGIN_TYPE) => setLoginType(type)}
              afterLoginSuccess={afterLoginSuccess}
              onNotAgree={onNotAgree}
            />
          </div>
        </div>

        {/* 协议 */}
        {Agreement}
      </div>
    </div>
  )
}
